import { createStore, combineReducers, compose, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

// REDUCERS
import officeReducer from './reducers/officeReducer';
import estadoReducer from './reducers/listaEstadosReducer';
import cartReducer from './reducers/cartReducer';
import shippingReducer from './reducers/shippingReducer';
import orderReducer from './reducers/orderReducer';
import referralReducer from './reducers/referralReducer';
import shippingCostReducer from './reducers/shippingCostReducer';

const reducers = combineReducers({
  officeSelection: officeReducer,
  estadoSelection: estadoReducer,
  cartInfo: cartReducer,
  shippingInfo: shippingReducer,
  orderInfo: orderReducer,
  referralInfo: referralReducer,
  shippingCost: shippingCostReducer,
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default function generateStore() {
  const store = createStore(reducers, composeEnhancers(applyMiddleware(thunk)));
  return store;
}
